var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"wrap"}},[_c('swiper',{ref:"mySwiper",attrs:{"slides-per-view":5,"space-between":50},on:{"slideChange":_vm.slideChange}},[_c('swiper-slide',[_c('img',{attrs:{"src":require("@/assets/img/card/ESLA04/slide1.png"),"alt":""}})])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }